/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/UnfoldMore';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const UnfoldMoreIcon = withMuiAdapter(Base, 'UnfoldMore');
